/* Atelier Thermea – interactions de la page produit « thermea » */
(function () {
  if (window.__thermeaInit) return;
  window.__thermeaInit = true;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Ajoute n jours ouvrés (lundi à vendredi) à une date
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-th-delivery]').forEach(function (el) {
      var shipMax = parseInt(el.dataset.shipMax || '2', 10);
      var delMin = parseInt(el.dataset.delMin || '8', 10);
      var delMax = parseInt(el.dataset.delMax || '14', 10);
      var now = new Date();
      var ship = el.querySelector('[data-th-ship]');
      var del = el.querySelector('[data-th-deliver]');
      if (ship) ship.textContent = fmt(addBusinessDays(now, 1)) + ' – ' + fmt(addBusinessDays(now, shipMax));
      if (del) del.textContent = fmt(addBusinessDays(now, 1 + delMin)) + ' – ' + fmt(addBusinessDays(now, shipMax + delMax));
    });
  }

  function initLevels(root) {
    root.querySelectorAll('[data-th-levels]').forEach(function (wrap) {
      var vis = wrap.querySelector('.th-lvl-vis');
      var t = wrap.querySelector('[data-th-temp]');
      var n = wrap.querySelector('[data-th-name]');
      var tabs = wrap.querySelectorAll('.th-lvl-tabs button');
      function set(b) {
        tabs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        if (vis) vis.style.setProperty('--lg', b.dataset.glow);
        if (t) t.textContent = b.dataset.temp;
        if (n) n.textContent = b.dataset.name;
      }
      tabs.forEach(function (b) { b.addEventListener('click', function () { set(b); }); });
      if (tabs.length) set(tabs[Math.min(1, tabs.length - 1)]);
    });
  }

  function initCalc(root) {
    root.querySelectorAll('[data-th-calc]').forEach(function (box) {
      var price = parseInt(box.dataset.price, 10);
      var range = box.querySelector('input[type=range]');
      var out = box.querySelector('[data-th-cost]');
      var sess = box.querySelector('[data-th-sessions]');
      var freq = box.querySelector('[data-th-freq]');
      function upd() {
        var perWeek = parseInt(range.value, 10);
        var s = perWeek * 52;
        if (freq) freq.textContent = perWeek;
        if (sess) sess.textContent = s + ' séances';
        if (out) out.textContent = money(Math.round(price / s));
      }
      range.addEventListener('input', upd);
      upd();
    });
  }

  function mainSubmit() {
    return document.querySelector('product-info product-form .product-form__submit') ||
      document.querySelector('product-form .product-form__submit');
  }

  function initSticky() {
    var bar = document.querySelector('[data-th-sticky]');
    var btn = mainSubmit();
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var action = bar.querySelector('[data-th-sticky-btn]');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (action) action.tabIndex = show ? 0 : -1;
    }).observe(btn);
    if (action) action.addEventListener('click', function () {
      var b = mainSubmit();
      if (b && !b.disabled) { b.click(); }
      else { b && b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  // Les boutons « retour à l'offre » remontent au bloc d'achat
  function initScrollers(root) {
    root.querySelectorAll('[data-th-to-buy]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var target = document.querySelector('product-info .product__info-wrapper') || document.querySelector('product-info');
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initAll(root) {
    initDelivery(root);
    initLevels(root);
    initCalc(root);
    initScrollers(root);
  }

  function boot() {
    initAll(document);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Éditeur de thème : réinitialiser une section quand elle est rechargée
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
